/* eslint-disable */
import PropTypes from "prop-types";
import "./styles/sample-card.scss";
import { useContext } from "react";
import CollectionContext from "modules/quickship/paramSlugPage/context/CollectionContext";
import { capitalizeWords } from "modules/quickship/utils/capitalizeWords";

const SampleCard = ({ sample }) => {
const { setSelectedItemCollection } = useContext(CollectionContext);

const handleUpdateSampleState = (sample) => {
    setSelectedItemCollection(sample)
  };

  const { selectedItemCollection } = useContext(CollectionContext);

  const handleChangeSampleDetails = (sample) => {
    console.log(`🚀🚀🚀 ~ handleChangeSampleDetails ~ sample:`, sample)
  };

  return (
    <div
      className={"card-color-quickship container-card--quickship"}
      style={{
        border: sample?.product?.id === selectedItemCollection?.product?.id ? '2px solid #98989A' : '2px solid #ffffff'
      }}
      onClick={() => handleUpdateSampleState(sample)}
    >
      <div className="d-flex align-items-center justify-content-center position-relative">
        <img
          className="img-card--quickship"
          src={sample?.product?.imageForProduction}
          alt="sample-image"
        />
        <p className="name-collection">{capitalizeWords(sample?.product?.pattern?.name)}</p>
      </div>
      <div className="card-container-info--quickship">
        <p className="card-label--quickship">{capitalizeWords(sample?.product?.color)}</p>
        <p className="card-stock--quickship">{sample?.product?.stock}</p>
      </div>
    </div>
  );
};

SampleCard.propTypes = {
  sample: PropTypes.object,
  handleClick: PropTypes.func,
};

export default SampleCard;
